import React from "react";
import stylesForms from "./styles/auth-forms.module.css";

export default function AuthForm({
  title,
  children, // Form fields passed as children
  onSubmit,
  buttonText,
  loading,
  error,
  successMessage,
  additionalLinks, // Additional links (e.g., Forgot Password, Back to Login)
  disabled,
}) {
  return (
    <>
      <div className={stylesForms.formTitle}>{title}</div>
      <div className={stylesForms.formContainer}>
        <form onSubmit={onSubmit} className={stylesForms.form}>
          {children}
          <button
            type="submit"
            className={`${stylesForms.button} ${loading ? stylesForms.buttonDisabled : ""}`}
            disabled={loading || disabled}
            aria-busy={loading}
          >
            <span className={loading ? stylesForms.buttonTextInvisible : ""}>
              {buttonText}
            </span>
            {loading && (
              <div className={stylesForms.buttonSpinner}>
                <svg
                  className={stylesForms.spinner}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className={stylesForms.spinnerCircle}
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className={stylesForms.spinnerPath}
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              </div>
            )}
          </button>
        </form>
        {error && (
          <div className={stylesForms.error} role="alert" aria-live="polite">
            {error}
          </div>
        )}
        {successMessage && (
          <div
            className={stylesForms.successMessage}
            role="alert"
            aria-live="polite"
          >
            {successMessage}
          </div>
        )}
        {additionalLinks && (
          <div className={stylesForms.linkContainer}>{additionalLinks}</div>
        )}
      </div>
    </>
  );
}
